export const TeamFilterVariables = { filters: 'TeamFilters' };
